module.exports = __webpack_public_path__ + "static/media/stop-circle.1356d152.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trailways/stop-circle.svg
// module id = 940
// module chunks = 0